import React from 'react'
import styled from 'styled-components'

const ChildBox = styled.div`
  border-radius: 10px;
  border: solid 1px lightgrey;
  padding: 20px 10px;
  margin-top: 30px;
`

const ContactForm = (props) => {
  const {
    handleNextClick,
    handleBackClick,
    handleChildAdd,
    handleChildRemove,
    handleChange,
    handleChildInputChange,
    handleGuardianClick,
    isGuardian,
    formData} = props

  const isDisabled = !formData.name || !formData.email || !formData.phone

  return (
    <section className="section">
      <div className="columns is-centered">
        <div className="column is-5 is-desktop">
          <h1 className="title is-1">
            How do we get in touch with you?
          </h1>
          <div className="animated fadeIn">
            <div className="field">
              <label className="label">Full Name</label>
              <div className="control">
                <input onChange={e => handleChange(e)}
                       className="input is-medium"
                       type="text"
                       placeholder="Your Full Name"
                       value={formData && formData.name}
                       name="name"/>
              </div>
            </div>

            <div className="field">
              <label className="label">Email</label>
              <div className="control has-icons-left has-icons-right">
                <input onChange={e => handleChange(e)}
                       className="input is-medium"
                       type="email"
                       value={formData.email}
                       placeholder="name@email.com"
                       name="email"/>
                <span className="icon is-small is-left">
                <i className="fas fa-envelope"></i>
              </span>
                {/*<span className="icon is-small is-right">*/}
                {/*<i className="fas fa-exclamation-triangle"></i>*/}
                {/*</span>*/}
              </div>
              {/*<p className="help is-danger">This email is invalid</p>*/}
            </div>

            <div className="field">
              <label className="label">Phone Number</label>
              <div className="control has-icons-left">
                <input onChange={e => handleChange(e)}
                       className="input is-medium"
                       type="text"
                       placeholder="(123) 456-7890"
                       value={formData.phone}
                       name="phone"/>
                <span className="icon is-small is-left">
                <i className="fas fa-phone"></i>
              </span>
              </div>
            </div>

            <div className="field">
              <div className="control">
                <label className="checkbox">
                  <input onChange={() => handleGuardianClick()} type="checkbox" name="isGuardian"/>
                  <span> I am signing up for my child / children</span>
                </label>
              </div>
            </div>

            { isGuardian &&
              <ChildBox>
                { formData && formData.children.map((child, i) => {
                  return (
                    <div key={i} className="field is-horizontal">
                      <div className="field-body">
                        <div className="field">
                          <p className="control is-expanded">
                            <input value={child.name}
                                   name="name"
                                   onChange={(e) => handleChildInputChange(e, i)}
                                   className="input is-medium"
                                   type="text"
                                   placeholder="Full Name"/>
                          </p>
                        </div>
                        <div className="field">
                          <p className="control is-expanded">
                            <input name="age"
                                   onChange={(e) => handleChildInputChange(e, i)}
                                   className="input is-medium"
                                   type="text"
                                   placeholder="Age"/>
                          </p>
                        </div>
                        <div className="field">
                          <span onClick={() => handleChildRemove(i)}>
                            <i className="far fa-trash-alt"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  )
                })}
                <div className="level">
                  <div className="level-left">
                  <span onClick={() => handleChildAdd()} value={isGuardian} className="level-item has-text-link" style={{cursor: 'pointer'}}><i
                    className="far fa-plus-square" style={{fontSize: 20, marginRight: 5}}></i> Add Child</span>
                  </div>
                  <div className="level-right"></div>
                </div>
              </ChildBox>
            }

            <div className="field is-grouped is-grouped-right" style={{marginTop: 10}}>
              <p className="control">
                <a className="button is-outline is-medium" onClick={() => handleBackClick()}>
                  Back
                </a>
              </p>
              <p className="control">
                <button disabled={isDisabled} className="button is-primary is-medium" onClick={() => handleNextClick()}>
                  Confirm
                </button>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ContactForm


// WEBPACK FOOTER //
// ./src/views/ContactForm.js